import { lazy } from 'react';

export default [
  {
    title: 'Client Eform Dashboard',
    component: lazy(() => import('./ClientEform-Dashboard')),
    url: '/client/dashboard',
    heading: 'CreateQuestionnaires',
    requirePermission: true,
    roles: ['Client'],
  },
  {
    title: 'Client Eform Account',
    component: lazy(() => import('./ClientEform-Account')),
    url: '/client/account',
    heading: 'CreateQuestionnaires',
    requirePermission: true,
    roles: ['Client'],
  },
  {
    title: 'Questionnarie',
    component: lazy(() => import('./ViewQuestionForms')),
    url: '/questionnaires/viewform/:id/:shareId',
    heading: 'Questionnarie',
    requirePermission: true,
    roles: ['Client'],
  },
  {
    title: 'Questionnarie',
    component: lazy(() => import('./ViewQuestionForms')),
    url: '/questionnaires/editform/:id/:shareId',
    heading: 'Questionnarie',
    requirePermission: true,
    roles: ['Client'],
  },
];
